import React, { useState } from 'react'
import { SearchableSelectBase } from 'components'
import { useCampaignsOptions } from '../../hooks'

type Props = {
  workspaceId: number
  initialOption: SelectOption
  disabled?: boolean
  onSelect: (selectOption: SelectOption) => void
  allowClear?: boolean
  placeholder?: string
  className?: string
}

const CampaignsSelect = (props: Props) => {
  const { workspaceId } = props

  const [searchText, setSearchText] = useState<string>('')
  const { data, isLoading } = useCampaignsOptions({ workspaceId, searchText })

  return (
    <SearchableSelectBase
      {...props}
      options={data?.map((item) => ({ id: item.id, name: item.name }))}
      onSearch={(newSearchText: string) => setSearchText(newSearchText)}
      isLoading={isLoading}
    />
  )
}

export default CampaignsSelect
